
document.addEventListener('DOMContentLoaded', () => {
  const toggleBtn = document.querySelector('#menuToggle');
  const menu = document.querySelector('#customMenu');
  const icon = document.querySelector('.menu-icon');

  if (toggleBtn) {
    toggleBtn.addEventListener('click', () => {
      menu.classList.toggle('active');
      icon.classList.toggle('rotated');
    });
  }

  // Optional: Replace featured collection with text when links clicked
  const featured = document.querySelector('.featured-collection');
  const termsLink = document.querySelector('#termsLink');
  const contactLink = document.querySelector('#contactLink');

  if (termsLink && featured) {
    termsLink.addEventListener('click', e => {
      e.preventDefault();
      featured.innerHTML = `<div class="text-page"><h2>TERMS</h2><p>Your terms text here...</p></div>`;
    });
  }

  if (contactLink && featured) {
    contactLink.addEventListener('click', e => {
      e.preventDefault();
      featured.innerHTML = `<div class="text-page"><h2>CONTACT</h2><p>Your contact info here...</p></div>`;
    });
  }
});